import { Routes, Route } from 'react-router-dom'
import { SetupProfilePage } from '../pages/setup/SetupProfilePage'
import { SetupPurposePage } from '../features/setupFlow/pages/setup/SetupPurposePage'
import { SetupIntentPage } from '../features/setupFlow/pages/setup/SetupIntentPage'
import { OnboardingPage } from '../features/setupFlow/pages/onboarding/OnboardingPage'
import HomeLayout from '../pages/HomeLayout'
import { QuickAddWindow } from '../windows/QuickAddWindow/QuickAddWindow'
import { FocusWindow } from '../windows/FocusWindow'
import { SyncProvider } from '../contexts/SyncProvider'
import { ErrorBoundary } from '../components/common/ErrorBoundary'
import { ProtectedRoute } from './ProtectedRoute'
import { useBackupSyncBridge } from '../hooks/useBackupSyncBridge'
import { SetupRoute } from './SetupRoute'

/** Hängt unter dem `SyncProvider`: Das Einstellungsfenster bittet hierüber um einen Sync (Backups, #158). */
function BackupSyncBridge() {
  useBackupSyncBridge()
  return null
}

export function ElectronRoutes() {
  return (
    <SyncProvider>
      <BackupSyncBridge />
      <ErrorBoundary variant="inline" name="ElectronRoutes">
        <Routes>
          <Route path="/" element={<SetupRoute />} />
          <Route path="/setup-profile" element={
            <ProtectedRoute><SetupProfilePage /></ProtectedRoute>
          } />
          <Route path="/setup-purpose" element={
            <ProtectedRoute><SetupPurposePage /></ProtectedRoute>
          } />
          <Route path="/setup-intent" element={
            <ProtectedRoute><SetupIntentPage /></ProtectedRoute>
          } />
          <Route path="/onboarding" element={
            <ProtectedRoute><OnboardingPage /></ProtectedRoute>
          } />
          <Route path="/home/*" element={
            <ProtectedRoute><HomeLayout /></ProtectedRoute>
          } />
          <Route path="/quick-add" element={
            <ProtectedRoute curtain={false}><QuickAddWindow /></ProtectedRoute>
          } />
          {/*
            **Das Fokus-Fenster.** Ohne `ProtectedRoute`: Der zeigt beim Laden
            einen `LogoScreen` über die ganze Fläche, und der stünde sichtbar
            falsch in einem 330 × 58 großen, durchsichtigen Fenster. Zu holen
            gibt es hier ohnehin nichts, was nicht schon lokal liegt.
          */}
          <Route path="/focus" element={<FocusWindow />} />
        </Routes>
      </ErrorBoundary>
    </SyncProvider>
  )
}
